import { Result, TransportAbstractionBuilder } from "@peercolab/engine";

export function peerColabInterceptors(builder: TransportAbstractionBuilder): void {
  builder
    .interceptPattern("PeerColab.Instructions.", async (input, ctx) => {
      const response = await fetch("https://instructions.peercolab.com/api", {
          method: "POST",
          headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + getToken()
          },
          body: ctx.serializeRequest(input)
      });
      const data = await response.text();
      if (!response.ok) {
          return Result.failed(response.status, data)
      }
      return ctx.deserializeResult(data)
    })
}

function getToken() {
  return 'Wj8rgS2JG7u6XPBDvgoX4tS1Ld6zcl'
}